class GoldupgradeController {
    constructor($translate) {
        'ngInject';
        this.name = 'goldupgrade';
        this.$translate = $translate;
    }

    $onInit() {
        this.translations = this.$translate.instant([
            "gp_exists",
            "too_late"
        ]);
        
        this.booking.message = this.translations[this.status];
    }
}

export default GoldupgradeController;



// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/goldupgrade/goldupgrade.controller.js